import { render, staticRenderFns } from "./ProjectIntegrationSystemBadge.vue?vue&type=template&id=725edd23"
import script from "./ProjectIntegrationSystemBadge.vue?vue&type=script&lang=js"
export * from "./ProjectIntegrationSystemBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports